import { useCallback, useEffect } from 'react';
import { useJobStory } from 'rwl-ui';
import { setHistoryState } from '../utils/setHistoryState';

const JOBID_URL_KEY = 'jobID';

export const useJobIdParam = () => {
    const { setJobStoryId, jobStoryId } = useJobStory();

    const setStateFromUrl = useCallback(() => {
        const params = new URLSearchParams(window.location.search);

        // update the URL with the currently selected job
        const jobId = params.get(JOBID_URL_KEY);
        if (jobId) {
            setJobStoryId(jobId);
        } else {
            setJobStoryId(undefined);
        }
    }, []);

    // Set job on page load
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const jobId = searchParams.get(JOBID_URL_KEY);
        if (jobId) {
            setJobStoryId(jobId);
        }
    }, []);

    // Update the job on back/forward
    useEffect(() => {
        window.addEventListener('popstate', setStateFromUrl);
        return () => {
            window.removeEventListener('popstate', setStateFromUrl);
        };
    }, [setStateFromUrl]);

    // When job changes update the URL
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        // update the URL with the currently selected job
        if (jobStoryId) {
            searchParams.set(JOBID_URL_KEY, jobStoryId);
            setHistoryState(searchParams);
        } else {
            // when they close the job modal
            searchParams.delete(JOBID_URL_KEY);
            setHistoryState(searchParams);
        }
    }, [jobStoryId]);
};
